import * as React from "react"
import Svg, { Path } from "react-native-svg"

const GymIcon = (props) => (
    <Svg
        width={props.size}
        height={props.size}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.102 19.13V2.87c0-.757-.573-1.37-1.282-1.37-.708 0-1.282.613-1.282 1.37v16.26c0 .757.574 1.37 1.282 1.37.709 0 1.282-.613 1.282-1.37ZM16.82 0c-1.483 0-2.686 1.285-2.686 2.87v16.26c0 1.585 1.203 2.87 2.686 2.87 1.484 0 2.687-1.285 2.687-2.87V2.87c0-1.585-1.203-2.87-2.687-2.87Z"
            fill={props.color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.102 19.13V2.87c0-.757-.573-1.37-1.282-1.37-.708 0-1.282.613-1.282 1.37v16.26c0 .757.574 1.37 1.282 1.37.709 0 1.282-.613 1.282-1.37ZM16.82 0c-1.483 0-2.686 1.285-2.686 2.87v16.26c0 1.585 1.203 2.87 2.686 2.87 1.484 0 2.687-1.285 2.687-2.87V2.87c0-1.585-1.203-2.87-2.687-2.87ZM6.462 19.13V2.87c0-.757-.574-1.37-1.282-1.37-.709 0-1.283.613-1.283 1.37v16.26c0 .757.574 1.37 1.283 1.37.708 0 1.282-.613 1.282-1.37ZM5.18 0C3.696 0 2.493 1.285 2.493 2.87v16.26c0 1.585 1.203 2.87 2.687 2.87 1.483 0 2.686-1.285 2.686-2.87V2.87C7.866 1.285 6.663 0 5.18 0Z"
            fill={props.color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.462 19.13V2.87c0-.757-.574-1.37-1.282-1.37-.709 0-1.283.613-1.283 1.37v16.26c0 .757.574 1.37 1.283 1.37.708 0 1.282-.613 1.282-1.37ZM5.18 0C3.696 0 2.493 1.285 2.493 2.87v16.26c0 1.585 1.203 2.87 2.687 2.87 1.483 0 2.686-1.285 2.686-2.87V2.87C7.866 1.285 6.663 0 5.18 0Z"
            fill={props.color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.164 12.435c0-.414.314-.75.702-.75h6.268c.388 0 .702.336.702.75s-.314.75-.702.75H7.866c-.388 0-.702-.336-.702-.75ZM7.164 9.565c0-.414.314-.75.702-.75h6.268c.388 0 .702.336.702.75s-.314.75-.702.75H7.866c-.388 0-.702-.336-.702-.75ZM0 7.652C0 6.182 1.116 4.99 2.493 4.99v1.5c-.601 0-1.089.52-1.089 1.163v6.696c0 .642.488 1.163 1.09 1.163v1.5C1.115 17.01 0 15.819 0 14.348V7.652ZM22 7.652c0-1.47-1.116-2.663-2.493-2.663v1.5c.601 0 1.089.52 1.089 1.163v6.696c0 .642-.488 1.163-1.09 1.163v1.5c1.378 0 2.494-1.192 2.494-2.663V7.652Z"
            fill={props.color}
        />
    </Svg>
)

export default GymIcon
